import React from "react";
export function LightCleanAdminVerify({ verified }: { verified: boolean }) {
  return (
    <div className={`fs-loading-wrap` + (verified ? " removed" : "")}>
      <div style={{ textAlign: "center" }}>
        <img src="/assets/loading2.gif" alt="" />
        <p>Loading the application</p>
      </div>
    </div>
  );
}
